import routes from '@modules/news/news-routes';
import store from '@modules/news/news-store';

export default {
  routes,
  store,
};
